import React from 'react';
import ReactDOM from 'react-dom/client';
import 'fontsource-roboto';
import 'fontsource-roboto/100.css';
import 'fontsource-roboto/300.css';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
